import * as React from "react";
import { Grid } from "@material-ui/core";
import { SpaciousPaper } from "./styleComponents";
import { useTypedSelector } from "../state/store";
import MarkdownText from "./MarkdownText";

var LaterQuizItemAddition = function LaterQuizItemAddition(_a) {
  var item = _a.item;
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });

  if (!languageInfo) {
    return React.createElement("div", null, "Language not set");
  }

  var message = languageInfo.general.answerMissingBecauseQuizModifiedLabel;
  return React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, React.createElement(MarkdownText, null, item.texts[0].title + " (" + item.type + ")")), React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, React.createElement(SpaciousPaper, {
    style: {
      backgroundColor: "lightgray"
    }
  }, message)));
};

export default LaterQuizItemAddition;